import React from "react";
import { IActivities } from "../../../../interface/IActivities";
import GenericUtils from "../../../../../../utils/GenericUtils";
import DateUtils from "../../../../../../utils/DateUtils";

interface IBodyProps {
    activities: IActivities[];
}

const TBody: React.FC<IBodyProps> = ({ activities }) => {
    return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
            {activities?.map((activity) => (
                <tr>
                    <td>
                        {GenericUtils.capitalizeWordFirstLetter(
                            activity.cartaoTipo.cartaoTipoNome
                        )}
                    </td>
                    <td>{activity.titulo}</td>
                    <td>
                        {DateUtils.formatStringToBrazilianFormat(activity.data)}
                    </td>
                    <td>{`${activity.horaInicio} - ${activity.horaFim}`}</td>
                    {activity.situacao && <td>{activity.situacao || "-"}</td>}
                </tr>
            ))}
        </>
    );
};

export default TBody;
